
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["timeoutPost","timeoutGet","timeoutPut"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "93c5eb816c8e2edc7823.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			